/// <reference path="~/js/indicatorSelection/IndicatorSelectionTreeView.js"/>
/// <reference path="~/js/indicatorSelection/IndicatorSelectionModel.js"/>
/// <reference path="~/js/indicatorSelection/IndicatorSelectionButtonsView.js"/>
/// <reference path="~/js/viz/shared/views/WindowshadeView.js"/>

(function($, _) {
  "use strict";
  var ns;

  ns = window.nspace("ccc.viz.shared");

  /**
   * The main visualization application class
   * @param options A configuration object.
   */
  ns.VizApp = function(options) {
    var self = this;

    if (!options) {
      throw "A configuration object needs to be passed when constructing.";
    }

    if (!options.indicatorGroupId) {
      throw "An indicatorGroupId needs to be passed in the configuration object.";
    }

    if (!options.routerType) {
      throw "A routerType needs to be passed in the configuration object.";
    }

    // Init the router
    this.router = new options.routerType({
      indicatorGroupId: options.indicatorGroupId,
      tabsSelector: "ul.map-table-tabs-list li a:not(.active)",
      dispatcher: ns.VizApp.dispatcher
    });

    this.model = new window.ccc.indicatorSelection.IndicatorSelectionModel();

    // Init the indictor selection view
    this.treeView = new window.ccc.indicatorSelection.IndicatorSelectionTreeView(
      {
        model: this.model
      }
    );
    this.buttonView = new window.ccc.indicatorSelection.IndicatorSelectionButtonsView(
      {
        model: this.model,
        optOutOfLinkRewrite: true
      }
    );
    this.windowshadeView = new window.ccc.viz.shared.views.WindowshadeView({
      model: this.model
    });

    this.initialRenderPromise = $.Deferred();

    ns.VizApp.dispatcher.once("initial-render-complete", function() {
      self.initialRenderPromise.resolve();
    });
  };

  /**
   * VizApp Prototype
   */
  (function(proto) {
    proto.start = function() {
      // Start Backbone's history tracking
      Backbone.history.start();
    };
  })(ns.VizApp.prototype);

  /**
   * Global "static" VizApp event dispatcher
   */
  ns.VizApp.dispatcher = _.clone(Backbone.Events);
})(jQuery, _);
